<template>
  <transition name="fade" mode="out-in">
    <div v-if="html" class="x-terms-of-service">
      <div v-html="html"/>
    </div>
    <spinner v-else class="m-y-5 m-x-auto"/>
  </transition>
</template>

<script>
import {
  getTosId,
  getTosById,
} from '@homeservices/api-kit/security/tos';

export default {
  name: 'service-terms',
  metaInfo: {
    title: 'Terms of Service',
  },
  data () {
    return {
      html: null,
    };
  },
  async mounted () {
    try {
      const key = this.$route.params.userType;
      const { data: { id } } = await getTosId(key);
      const { data: html } = await getTosById(id);
      this.html = html;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  },
};
</script>
